const UNSPECIFIED_OPTION_TEXT = 'Unspecified';

// these are taken from EQUATES/CRD.APP.DYN for D.CAP.ADDL.APP.IND
export const APP_TYPE_INDIVIDUAL = 'I';
export const APP_TYPE_CUSTOMER_JOINT = 'C';

export const PERSONAL_INFORMATION = 'personalInformation';
export const CURRENT_EMPLOYMENT = 'currentEmployment';
export const CURRENT_RESIDENCE = 'currentResidence';
export const PREVIOUS_EMPLOYMENT = 'previousEmployment';
export const PREVIOUS_RESIDENCE = 'previousResidence';
export const PERSONAL_REFERENCES = 'references';
export const COAPP_PERSONAL_INFORMATION = 'coAppPersonalInformation';
export const COAPP_CURRENT_EMPLOYMENT = 'coAppCurrentEmployment';
export const COAPP_CURRENT_RESIDENCE = 'coAppCurrentResidence';

export const APP_TYPE_OPTIONS = [
	{ displayText: 'Single Applicant', value: APP_TYPE_INDIVIDUAL },
	{ displayText: 'Joint Applicants', value: APP_TYPE_CUSTOMER_JOINT },
];

export const DATE_RANGE_START_YEAR = 1800;
export const DATE_RANGE_START_MONTH = 0;
export const DATE_RANGE_START_DAY = 1;

export const MARITAL_STATUS_OPTIONS = [
	{ displayText: 'Married', value: 'M' },
	{ displayText: 'Single', value: 'S' },
	{ displayText: 'Divorced', value: 'D' },
	{ displayText: 'Widowed', value: 'W' },
];

export const HOUSING_POSITION_UNSPEFICIED = 0;
export const HOUSING_POSITION_OWN = 1;
export const HOUSING_POSITION_RENT = 2;
export const HOUSING_POSITION_PARENTS_RELATIVE = 3;
export const HOUSING_POSITION_OTHER = 4;

// this is hardcoded in the STORIS screen - FR_070_STD_APP_SUB.sfd
export const OWN_RENT_OPTIONS = [
	{ displayText: UNSPECIFIED_OPTION_TEXT, value: '' },
	{ displayText: 'Own', value: '1' },
	{ displayText: 'Rent', value: '2' },
	{ displayText: 'Parents/Relative', value: '4' },
	{ displayText: 'Other', value: '3' },
];
export const INCOME_TYPE_OPTIONS = [
	{ displayText: 'Monthly', value: 'M' },
	{ displayText: 'Annual', value: 'A' },
];
export const STATES = [
	{ displayText: 'Alabama', value: 'AL' },
	{ displayText: 'Alaska', value: 'AK' },
	{ displayText: 'Arizona', value: 'AZ' },
	{ displayText: 'Arkansas', value: 'AR' },
	{ displayText: 'California', value: 'CA' },
	{ displayText: 'Colorado', value: 'CO' },
	{ displayText: 'Connecticut', value: 'CT' },
	{ displayText: 'Delaware', value: 'DE' },
	{ displayText: 'District Of Columbia', value: 'DC' },
	{ displayText: 'Florida', value: 'FL' },
	{ displayText: 'Georgia', value: 'GA' },
	{ displayText: 'Guam', value: 'GU' },
	{ displayText: 'Hawaii', value: 'HI' },
	{ displayText: 'Idaho', value: 'ID' },
	{ displayText: 'Illinois', value: 'IL' },
	{ displayText: 'Indiana', value: 'IN' },
	{ displayText: 'Iowa', value: 'IA' },
	{ displayText: 'Kansas', value: 'KS' },
	{ displayText: 'Kentucky', value: 'KY' },
	{ displayText: 'Louisiana', value: 'LA' },
	{ displayText: 'Maine', value: 'ME' },
	{ displayText: 'Maryland', value: 'MD' },
	{ displayText: 'Massachusetts', value: 'MA' },
	{ displayText: 'Michigan', value: 'MI' },
	{ displayText: 'Minnesota', value: 'MN' },
	{ displayText: 'Mississippi', value: 'MS' },
	{ displayText: 'Missouri', value: 'MO' },
	{ displayText: 'Montana', value: 'MT' },
	{ displayText: 'Nebraska', value: 'NE' },
	{ displayText: 'Nevada', value: 'NV' },
	{ displayText: 'New Hampshire', value: 'NH' },
	{ displayText: 'New Jersey', value: 'NJ' },
	{ displayText: 'New Mexico', value: 'NM' },
	{ displayText: 'New York', value: 'NY' },
	{ displayText: 'North Carolina', value: 'NC' },
	{ displayText: 'North Dakota', value: 'ND' },
	{ displayText: 'Ohio', value: 'OH' },
	{ displayText: 'Oklahoma', value: 'OK' },
	{ displayText: 'Oregon', value: 'OR' },
	{ displayText: 'Pennsylvania', value: 'PA' },
	{ displayText: 'Puerto Rico', value: 'PR' },
	{ displayText: 'Rhode Island', value: 'RI' },
	{ displayText: 'South Carolina', value: 'SC' },
	{ displayText: 'South Dakota', value: 'SD' },
	{ displayText: 'Tennessee', value: 'TN' },
	{ displayText: 'Texas', value: 'TX' },
	{ displayText: 'Utah', value: 'UT' },
	{ displayText: 'Vermont', value: 'VT' },
	{ displayText: 'Virgin Islands', value: 'VI' },
	{ displayText: 'Virginia', value: 'VA' },
	{ displayText: 'Washington', value: 'WA' },
	{ displayText: 'West Virginia', value: 'WV' },
	{ displayText: 'Wisconsin', value: 'WI' },
	{ displayText: 'Wyoming', value: 'WY' },
];

export const PERSONAL_REFERENCE_STATUS_FIELDS = [
	'referenceName',
	'referenceType',
	'referencePhone',
	'referenceAddress1',
	'referenceAddress2',
	'referenceCity',
	'referenceState',
	'referenceZip',
];

export const CURRENT_RESIDENCE_STATUS_FIELDS = [
	'housingOwnOrRent',
	'homePhone',
	'cellPhone',
	'housingTimeAtResidence',
	'housingHomeValue',
	'housingMonthlyPayment',
	'housingMortgageBalance',
];

export const PREVIOUS_RESIDENCE_STATUS_FIELDS = [
	'previousAddress1',
	'previousAddress2',
	'previousCity',
	'previousState',
	'previousZip',
	'previousTimeAtResidence',
];

export const CURRENT_EMPLOYMENT_STATUS_FIELDS = [
	'employmentStatus',
	'employer',
	'jobTitle',
	'employerPhone',
	'timeAtEmployer',
	'income',
	'incomeIndicator',
	'netIncome',
];

export const PREVIOUS_EMPLOYMENT_STATUS_FIELDS = ['previousEmployer', 'previousTimeAtEmployer'];

export const COAPP_CURRENT_RESIDENCE_STATUS_FIELDS = [
	'housingOwnOrRent',
	'homePhone',
	'cellPhone',
	'housingTimeAtResidence',
	'housingMonthlyPayment',
];

export const COAPP_CURRENT_EMPLOYMENT_STATUS_FIELDS = [
	'employer',
	'jobTitle',
	'employerPhone',
	'timeAtEmployer',
	'income',
	'incomeIndicator',
	'netIncome',
];

export const PRIMARY_SETTING = 'primary';

export const COAPP_SETTING = 'coApp';
